import React from "react";
import AdminCountriesRoutes from "./AdminCountriesRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminCountriesScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Countrys",
      page: "Admin Countrys Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminCountriesRoutes />
      </Track>
    </div>
  );
};

export default AdminCountriesScreen;
